import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ThunkDispatch } from "redux-thunk";
import {
  getCanPayEmployeeAsync,
  getTaxAgentAsync,
  loadBusinessUnitManagerSettingsAsync,
  loadCompaniesAsync,
  loadProfileToggleAsync,
  loadReceiptPaymentMethodsAsync,
  selectCompanyAsync,
} from "store/actions/authActions";
import { loadProfileLanguageAsync, loadSupportIssueCategoriesAsync } from "store/actions/commonActions";
import { loadLastViewedTab } from "store/actions/todoActions";
//#endregion
//#region types
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { BaseUrlParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import { useAllCompaniesTodoSetting, useCompanyService } from "serviceHooks";
import useSummerCampaignModal from "components/home/widgets/referAFriend/useSummerCampaignModal";
//#endregion
import { AuthHelper } from "utils/helpers";

function useInitialSetup() {
  const companyService = useCompanyService();
  const allCompaniesTodoSetting = useAllCompaniesTodoSetting();

  const [hasCompany, setHasCompany] = React.useState(false);
  const [companies, setCompanies] = React.useState<ApiModels.Company[] | undefined>();

  const { company } = useParams<BaseUrlParams>();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    // TODO: Migrate to useProfileService hook instead of Redux action
    // @deprecated loadProfileToggleAsync - Add a new useLoadProfileToggle hook
    dispatch(loadProfileToggleAsync());
    // TODO: Migrate to useTodoService hook instead of Redux action
    // @deprecated loadLastViewedTab - Add a new useLoadLastViewedTab hook
    dispatch(loadLastViewedTab());
    void allCompaniesTodoSetting.load();
  }, []);

  React.useEffect(() => {
    if (hasCompany) {
      // TODO: Migrate to useAuthService hook instead of Redux action
      // @deprecated getCanPayEmployeeAsync - Add a new useGetCanPayEmployee hook
      dispatch(getCanPayEmployeeAsync());
      // TODO: Migrate to useReceiptPaymentMethodService hook instead of Redux action
      // @deprecated loadReceiptPaymentMethodsAsync - Add a new useLoadReceiptPaymentMethods hook
      dispatch(loadReceiptPaymentMethodsAsync());
      // TODO: Migrate to useProfileService hook instead of Redux action
      // @deprecated loadProfileLanguageAsync - Add a new useLoadProfileLanguage hook
      dispatch(loadProfileLanguageAsync());
      // TODO: Migrate to useSupportService hook instead of Redux action
      // @deprecated loadSupportIssueCategoriesAsync - Add a new useLoadSupportIssueCategories hook
      dispatch(loadSupportIssueCategoriesAsync());
      // TODO: Migrate to useBusinessUnitService hook instead of Redux action
      // @deprecated loadBusinessUnitManagerSettingsAsync - Add a new useLoadBusinessUnitManagerSettings hook
      dispatch(loadBusinessUnitManagerSettingsAsync());
      // TODO: Migrate to useAuthService hook instead of Redux action
      // @deprecated getTaxAgentAsync - Add a new useGetTaxAgent hook
      dispatch(getTaxAgentAsync());
    }
  }, [hasCompany]);

  React.useEffect(() => {
    if (!companies)
      // TODO: Migrate to useCompanyService hook instead of Redux action
      // @deprecated loadCompaniesAsync - Add a new useLoadCompanies hook
      dispatch(loadCompaniesAsync() as unknown as Promise<ApiModels.Company[]>).then((result) => {
        setCompanies(result);
        if (!company) {
          if (result.length === 0) {
            navigate(`/NotFound`);
          }

          if (result.length === 1) {
            navigate(`/${result[0].url}`);
          } else {
            companyService.getSelectedCompanyId().then((selectedCompanyId) => {
              if (!company) {
                const selectedCompany = result.find((c) => c.id === selectedCompanyId);
                if (selectedCompanyId && selectedCompany) {
                  navigate(`/${selectedCompany.url}`);
                } else {
                  navigate(`/${result[0].url}`);
                }
              }
            });
          }
        } else {
          selectCompany(result);
        }
      });
    else selectCompany(companies);
  }, [company]);

  const selectCompany = (companyList: ApiModels.Company[]) => {
    if (company) {
      const selectedCompany = companyList.find((c) => c.url === company);
      if (selectedCompany) {
        setHasCompany(false);
        companyService.setSelectedCompanyId(selectedCompany.id);
        // TODO: Migrate to useCompanyService hook instead of Redux action
        // @deprecated selectCompanyAsync - Add a new useSelectCompany hook
        dispatch(selectCompanyAsync(selectedCompany.id) as unknown as Promise<void>).then(() => {
          if (AuthHelper.isSelectedCompany(selectedCompany!.id)) setHasCompany(true);
        });
      } else navigate(`/NotFound`, { replace: true });
    }
  };

  useSummerCampaignModal(hasCompany);

  return { hasCompany };
}

export default useInitialSetup;
